import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';
import { ModelTripSheet } from 'src/app/shared/models/trip-sheet';
import { ModelVendorMaster } from 'src/app/shared/models/vendor/vendor-master';
import { Location } from "@angular/common";
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { VehicleTypeCountComponent } from '../vehicle-type-count/vehicle-type-count.component';

@Component({
  selector: 'app-allocate-vendor',
  templateUrl: './allocate-vendor.component.html',
  styleUrls: ['./allocate-vendor.component.scss']
})
export class AllocateVendorComponent implements OnInit {

  _vendorData: ModelVendorMaster[] = [];
  _tripSheet: ModelTripSheet[] = [];
  showVendorDiv: boolean = true;
  showVendorRatioDiv: boolean = false;
  allocateVendorDndShow: boolean = true;
  allocateVendorRatio: boolean = false;
  addRemoveFlag: boolean = false;
  vechileTypeCount: any = [];
  vechileNames: any[] = [];
  _tripVechileNames: any = [];
  tripids: any = [];
  vTCount = [];
  siteid: any;
  shiftid: number;
  date: any;
  activeTabId = 1;
  isSorted: boolean = false;
  tripsv3: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private readonly apiService: ApiService,
    private serviceSharedData: ServiceSharedData,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.siteid = params["siteId"];
      this.shiftid = params["shiftId"];
      this.date = params["date"];
      this.tripsv3 = params["tripsv3"] === 'true';
    });
    this.tripids = this.serviceSharedData.getData("trips");
    this.getVendors();
  }

  onClickBack() {
    this.location.back();
  }

  getVendors() {
    // const tripId = this.route.snapshot.params.tripId;
    const siteId: any = this.tripsv3 ? this.siteid.split(",")[0] : this.siteid;
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.getVendorMaserBasedOnId + siteId, success => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        // this._vendorData = success.body;
        // this._vendorData.forEach((vendor, i) => {
        //   if (i == 0) {
        //     vendor.flag = true;
        //   } else {
        //     vendor.flag = false;
        //   }
        //   vendor.tripCount = 0;
        //   let innerlist: ModelTripSheet[] = [];
        //   vendor.trips = innerlist;
        // });
        this._vendorData = success.body.map((vendor, i) => ({
          ...vendor,
          flag: i === 0,
          tripCount: 0,
          trips: []
        }));
        this.getTripSheets();
        this.getTripSheets();
      } else {
        this.notifyService.showInfo("Oops ...Vendor Master Not found", null);
      }
    }, error => {
      this.ngxLoader.stop();
    });
  }

  getTripSheets() {
    const endPoint = this.tripsv3 ? ApiConstants.getmultiplesiteunassignedtripsV3 : ApiConstants.getunassignedtrips;
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(endPoint + this.date + '&shiftid=' + this.shiftid + '&siteid=' + this.siteid +
      '&tripids=' + [this.tripids], success => {
        if (success.body != null) {
          this._tripSheet = success.body;
          this._tripVechileNames = JSON.parse(JSON.stringify(success.body));
        }
        this.ngxLoader.stop();
      }, error => {
        this.ngxLoader.stop();
      });
  }

  // allocateVendor() {
  //   this.ngxLoader.start();
  //   let assignList: any[] = [];
  //   this._vendorData.forEach(vendor => {
  //     vendor.trips.forEach(trip => {
  //       if (trip.tripDetails.tripId != null) {
  //         assignList.push({
  //           tripId: trip.tripDetails.tripId,
  //           vendorId: vendor.id
  //         });
  //       }
  //     });
  //   });
  //   if (assignList.length > 0) {
  //     this.apiService.doPostRequestWithResponse(ApiConstants.allocatevendor, assignList, success => {
  //       this.ngxLoader.stop();
  //       if (success.status == 200) {
  //         this.ngOnInit();
  //         this.notifyService.showSuccess("Vendor allocated successfully", null);
  //       }
  //     }, error => {
  //       this.ngxLoader.stop();
  //       this.notifyService.showError(error.message, null);
  //     }
  //     );
  //   } else {
  //     this.ngxLoader.stop();
  //     this.notifyService.showWarning("Select atleast one trip", null);
  //   }
  // }

  allocateVendor() {
    this.ngxLoader.start();
    const assignList = this._vendorData.flatMap(vendor =>
      vendor.trips
        .filter(trip => trip.tripDetails.tripId != null)
        .map(trip => ({ tripId: trip.tripDetails.tripId, vendorId: vendor.id }))
    );
    if (!assignList.length) {
      this.ngxLoader.stop();
      return this.notifyService.showWarning("Select atleast one trip", null);
    }
    this.apiService.doPostRequestWithResponse(
      ApiConstants.allocatevendor,
      assignList,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.ngOnInit();
          this.notifyService.showSuccess(success.body.message, null);
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showError(error.message, null);
      }
    );
  }

  showVendorRatioDivision() {
    this.showVendorRatioDiv = true;
    this.showVendorDiv = false;
    this.allocateVendorDndShow = false;
    this.allocateVendorRatio = true;
  }

  showVendorDivision() {
    this.showVendorRatioDiv = false;
    this.showVendorDiv = true;
    this.allocateVendorDndShow = true;
    this.allocateVendorRatio = false;
  }

  // addVendorAllocation(data) {
  //   this._tripSheet.forEach((element, index) => {
  //     if (element == data) this._tripSheet.splice(index, 1);
  //   });
  //   this._vendorData.forEach(element => {
  //     if (element.flag) {
  //       element.trips.push(data);
  //       element.tripCount = element.tripCount + 1;
  //       this.addRemoveFlag = true;
  //     }
  //   });
  //   this.getVechileCount();
  // }

  addVendorAllocation(data) {
    const index = this._tripSheet.indexOf(data);
    if (index > -1) this._tripSheet.splice(index, 1);
    const activeVendor = this._vendorData.find(element => element.flag);
    if (activeVendor) {
      activeVendor.trips.push(data);
      activeVendor.tripCount++;
      this.addRemoveFlag = true;
    }
    this.getVechileCount();
  }

  // getVechileCount() {
  //   this.vechileTypeCount = [];
  //   const vhNamesList = this._tripVechileNames.flatMap(el => el.vehicleType.vehicleType);
  //   this.vechileNames = vhNamesList.filter((el, pos) => vhNamesList.indexOf(el) === pos);
  //   this.vechileNames.sort((a: any, b: any) => a - b);
  //   this._vendorData.forEach((element, index) => {
  //     const obj: any = {};
  //     this.vechileNames.forEach((el: any) => {
  //       obj[el] = 0
  //     });
  //     obj.name = element.name;
  //     this.vechileTypeCount[index] = obj;
  //     element.trips.forEach(trip => {
  //       const vhName = trip.vehicleType.vehicleType;
  //       this.vechileTypeCount[index][vhName] = (this.vechileTypeCount[index][vhName] || 0) + 1;
  //     });
  //   });
  // }

  getVechileCount() {
    const vhNamesList = this._tripVechileNames.flatMap(el => el.vehicleType.vehicleType);
    this.vechileNames = [...new Set(vhNamesList)].sort();
    this.vechileTypeCount = this._vendorData.map(vendor => {
      const obj = Object.fromEntries(this.vechileNames.map(name => [name, 0]));
      obj.name = vendor.name;
      vendor.trips.forEach(trip => {
        const vhName = trip.vehicleType.vehicleType;
        obj[vhName]++;
      });
      return obj;
    });
  }

  // removeVendorAllocation(vendor, data) {
  //   vendor.trips.forEach((element1, index) => {
  //     if (element1 == data) {
  //       vendor.trips.splice(index, 1);
  //       vendor.tripCount = vendor.tripCount - 1;
  //       this.addRemoveFlag = true;
  //     }
  //   });
  //   this._tripSheet.push(data);
  //   this.getVechileCount();
  // }

  removeVendorAllocation(vendor, data) {
    const index = vendor.trips.indexOf(data);
    if (index > -1) {
      vendor.trips.splice(index, 1);
      vendor.tripCount--;
      this.addRemoveFlag = true;
    }
    this._tripSheet.push(data);
    this.getVechileCount();
  }

  selectVendor(item) {
    // this._vendorData.forEach(element => {
    //   element.flag = false;
    // })
    // this._vendorData.forEach(element => {
    //   if (element.name == item.name) {
    //     element.flag = true;
    //   }
    // })
    this._vendorData.forEach(element => {
      element.flag = element.name === item.name;
    });
  }

  moveAll() {
    // this._vendorData.forEach(element => {
    //   if (element.flag) {
    //     this._tripSheet.forEach((element1) => {
    //       element.trips.push(element1);
    //       element.tripCount = element.tripCount + 1;
    //     });
    //   }
    // })
    // this._tripSheet = [];
    // this.getVechileCount();
    const activeVendor = this._vendorData.find(element => element.flag);
    if (activeVendor) {
      activeVendor.trips.push(...this._tripSheet);
      activeVendor.tripCount += this._tripSheet.length;
    }
    this._tripSheet = [];
    this.getVechileCount();
  }

  onVehicleTypeCount() {
    // if (this.addRemoveFlag) {
    //   this.vTCount = [];
    //   this.vTCount.push(this.vechileNames);
    //   this.vTCount.push(this.vechileTypeCount);
    //   this.openDialog(this.vTCount);
    // } else {
    //   this.vTCount.push(this.vechileNames);
    //   this.vTCount.push(this.vechileTypeCount);
    //   this.openDialog(this.vTCount);
    // }
    if (this.addRemoveFlag) this.vTCount = [];
    this.vTCount.push(this.vechileNames, this.vechileTypeCount);
    this.openDialog(this.vTCount);
  }

  openDialog(d): void {
    this.dialog.open(VehicleTypeCountComponent, {
      width: '600px',
      disableClose: true,
      data: d
    });
  }

  shortVehicle() {
    // if (!this.isSorted) {
    //   this._tripSheet.sort((a, b) => {
    //     return this.compare(a.vehicleType.vehicleType, b.vehicleType.vehicleType, true);
    //   });
    //   this.isSorted = true;
    // } else {
    //   this.rotateArray();
    // }
    if (!this.isSorted) {
      this._tripSheet.sort((a, b) => this.compare(a.vehicleType.vehicleType, b.vehicleType.vehicleType, true));
      this.isSorted = true;
    } else {
      this.rotateArray();
    }
  }

  rotateArray() {
    // if (this._tripSheet.length > 0) {
    //   const firstElement = this._tripSheet.shift();
    //   if (firstElement) {
    //     this._tripSheet.push(firstElement);
    //   }
    // }
    if (this._tripSheet.length > 0) {
      this._tripSheet.push(this._tripSheet.shift()!);
    }
  }

  compare(a: number | string, b: number | string, isAsc: boolean): number {
    if (a == null || b == null) return 0;
    if (typeof a === 'string' && typeof b === 'string') {
      return a.toLowerCase() < b.toLowerCase() ? -1 : a.toLowerCase() > b.toLowerCase() ? 1 : 0;
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  reset() {
    // this._tripSheet.sort((a, b) => {
    //   return this.compare(a.tripDetails.tripCode, b.tripDetails.tripCode, true);
    // });
    // this.isSorted = false;
    this._tripSheet.sort((a, b) => this.compare(a.tripDetails.tripCode, b.tripDetails.tripCode, true));
    this.isSorted = false;
  }


}
